module.exports = __webpack_public_path__ + "static/media/videoEditor-5.fab1b34b.webp";